export const GET_PARTNERS = gql`
    query GetPartners {
        partners {
            id
            firstName
            lastName
            email
            partnerOfPartner {
                id
                partner {
                    id
                    business {
                        legalName
                        id
                        hierarchyLevel
                        status
                    }
                }
                firstName
                lastName
                business {
                    legalName
                    id
                    hierarchyLevel
                    status
                }
            }
            business {
                legalName
                id
                hierarchyLevel
                status
            }
            primaryContactInformation
        }
    }
`;

export const GET_ACTIVE_PARTNERS = gql`
    query GetActivePartners {
        activePartners {
            id
            firstName
            lastName
            partnerOfPartner {
                id
                partner {
                    id
                    business {
                        legalName
                        id
                        hierarchyLevel
                        status
                    }
                }
                firstName
                lastName
                business {
                    legalName
                    id
                    hierarchyLevel
                    status
                }
            }
            business {
                legalName
                id
                hierarchyLevel
                status
            }
            primaryContactInformation
        }
    }
`;

export const GET_PARTNER = gql`
    query GetPartner($id: Int!) {
        partner(id: $id) {
            id
            firstName
            lastName
            logo
            business {
                legalName
                id
                hierarchyLevel
                hierarchyLevel
                businessType
                creditLimit
                currency
                language
                membershipNumber
                paymentTerms
                registeredNumber
                status
                taCode
                tradingName
                vatNumber
                vatValidatedAt
                website
                worldPayID
                businessTypeId
                accountManagerId
                merchantId
            }
            notes {
                id
                subject
                body
                createdAt
                createdById
                createdBy {
                    id
                    firstName
                    lastName
                }
            }
            merchants {
                id
                status
                business {
                    id
                }
            }
            offer {
                id
                name
                type
                createdAt
            }
            partnerAccountNumber
            documents {
                id
                locationURL
                type
            }
            bank {
                id
                bic
                iban
                sortCode
                accountNumber
            }
            contract
            telephoneNumber
            mobilePhoneNumber
            primaryContactInformation
            billingContactInformation
            serviceContactInformation
            transactionPricingOffers {
                id
                offerName
                createdAt
                status
            }
            services {
                terminalService {
                    merchantStatus
                    serviceType
                }
                onlineService {
                    merchantStatus
                    serviceType
                }
            }
            commission {
                id
                commissionType
                totalAmount
            }
            invoices {
                id
                totalInvoiceAmount
            }
            userCurrencyCode
        }
    }
`;

export const GET_PARTNERS_OFFERS = gql`
    query GetPartnersOffers($id: Int) {
        partnersOffers(id: $id) {
            id
            type
            term
            gpvHighest
            gpvLowest
            customTerm
            mcc {
                code
                id
            }
            primaryProducts {
                id
                name
                description {
                    type
                    text
                }
            }
            secondaryProducts {
                id
                name
                description {
                    type
                    text
                }
            }
            name
            transactionPricing {
                id
                offerName
                status
                transactionPricingCards {
                    name
                }
                additionalTariffCharges {
                    name
                }
                compliancePricingCharges {
                    name
                }
            }
        }
    }
`;
